/**
 * SearchBar Component
 *
 * Search bar for the header with location and date inputs.
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  className?: string;
  compact?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  className = '',
  compact = false,
}) => {
  const navigate = useNavigate();
  const [location, setLocation] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (location.trim()) {
      navigate(`/search?location=${encodeURIComponent(location.trim())}`);
    } else {
      navigate('/search');
    }
  };

  if (compact) {
    return (
      <button
        onClick={() => navigate('/search')}
        className={`flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-full shadow-sm hover:shadow-md transition-shadow ${className}`}
      >
        <SearchIcon className="w-4 h-4 text-gray-500" />
        <span className="text-sm text-gray-500">Where are you going?</span>
      </button>
    );
  }

  return (
    <form onSubmit={handleSearch} className={`relative ${className}`}>
      <div className="flex items-center border border-gray-300 rounded-full shadow-sm hover:shadow-md transition-shadow overflow-hidden">
        <div className="flex items-center flex-1 px-4 py-2">
          <SearchIcon className="w-5 h-5 text-gray-400 mr-2" />
          <input
            type="text"
            placeholder="Where are you going?"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className="flex-1 outline-none text-sm placeholder-gray-500 bg-transparent"
          />
        </div>
        <button
          type="submit"
          className="bg-primary-500 text-white px-4 py-2 m-1 rounded-full hover:bg-primary-600 transition-colors"
        >
          <SearchIcon className="w-4 h-4" />
        </button>
      </div>
    </form>
  );
};

const SearchIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

export default SearchBar;
